import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";
import {flutterCore, permissions} from "@hybird/flutter/bridge/core";
import {defaultError, WebError} from "@hybird/core/error";

export const FileType = Object.freeze({
  picture: 0,
  video: 1,
  file: 2,
});

export class FlutterFileIsolate extends BridgeMethod {
  constructor() {
    super();
  }


  async uploadFile(files, uploadUrl, {
    onFinish = null,
    onProgress = null,
    data = {},
    header = {},
    queryParameters = {},
    timeout = 30
  } = {}) {

    const flag = await flutterCore.requestPermission([permissions.storage]);

    if (!flag.isGranted) {
      throw WebError.code(defaultError.NOT_PERMISSION, {
        msg: "存储权限未授权, 请前往设置授权",
        data: flag.denied
      })
    }

    let call = invoke("uploadFile", {
      params: {
        'files': files,
        'uploadUrl': uploadUrl,
        'data': data,
        'header': header,
        'queryParameters': queryParameters,
        'timeout': timeout
      }, on: {
        "onProgress": (params) => {
          onProgress && onProgress(params['progress']);
        },
        'onFinish': (params) => {
          onFinish && onFinish(params)
          // cancel("onProgress", { event: call });
          // cancel("onFinish", { event: call });
        }
      }
    })
  }


  async downloadFile(downloadUrl, savePath, fileType, {
    onFinish = null,
    onProgress = null,
    header = {},
    queryParameters = {},
    timeout = 30
  } = {}) {
    const flag = await flutterCore.requestPermission([permissions.storage]);

    if (!flag.isGranted) {
      throw WebError.code(defaultError.NOT_PERMISSION, {
        msg: "存储权限未授权, 请前往设置授权",
        data: flag.denied
      })
    }

    const data = await invoke("downloadFile", {
      params: {
        'downloadUrl': downloadUrl,
        'savePath': savePath,
        'fileType': fileType,
        'header': header,
        'queryParameters': queryParameters,
        'timeout': timeout
      }, on: {
        "onProgress": (params) => {
          onProgress && onProgress(params['progress']);
        },
        'onFinish': (params) => {
          onFinish && onFinish(params)
          // cancel("onProgress", { event: call });
          // cancel("onFinish", { event: call });
        }
      }, parseResult: false
    })
    return () => {
      data?.method?.abort?.();
    }
  }
}

export const flutterFileIsolate = new FlutterFileIsolate();